import {
  QuestionDTO,
  StandardQuestionBulkUploadDTO,
  StandardQuestionUploadDTO,
  UploadFileDTO,
} from "../../../common/types/common.dto.types";
import { EnumBulkQuestionUploadPageMode } from "./BulkUploadQuestionsPage.types";

/* ==============================|| VIEWS - PAGES - BULK UPLOAD QUESTIONS PAGE - ACTION ||==============================  */

export const BULKUPLOADSTANDARDQUESTION = "BULKUPLOADSTANDARDQUESTION";

export const BULKUPLOADQUESTIONTYPEDROPDOWN = "BULKUPLOADQUESTIONTYPEDROPDOWN";

export const BULKUPLOADQUESTIONDROPDOWNCATEGORIES =
  "BULKUPLOADQUESTIONDROPDOWNCATEGORIES";

export const BULKUPLOADQUESTIONCATEGORYCHOICES =
  "BULKUPLOADQUESTIONCATEGORYCHOICES";

export const SAVEBULKUPLOADQUESTIONS = "SAVEBULKUPLOADQUESTIONS";

export const NOTIFYSTANDARDQUESTIONISSUESBYEMAIL =
  "NOTIFYSTANDARDQUESTIONISSUESBYEMAIL";

export const GETCHOICESDATAONROWCLICK = "GETCHOICESDATAONROWCLICK";

export const bulkUploadStandardQuestion = (
  uploadedStandardQuestion: UploadFileDTO
) => {
  return {
    type: BULKUPLOADSTANDARDQUESTION,
    payload: uploadedStandardQuestion,
  };
};

export const getBulkUploadQuestionTypeDropdown = () => {
  return {
    type: BULKUPLOADQUESTIONTYPEDROPDOWN,
  };
};

export const getBulkUploadQuestionDropdownCategories = (
  questionTypeId: number,
  selectedStandardQuestion?: StandardQuestionUploadDTO
) => {
  return {
    type: BULKUPLOADQUESTIONDROPDOWNCATEGORIES,
    payload: { questionTypeId, selectedStandardQuestion },
  };
};

export const getBulkUploadQuestionCategoryChoices = (
  questionData: QuestionDTO,
  selectedStandardQuestion?: StandardQuestionUploadDTO
) => {
  return {
    type: BULKUPLOADQUESTIONCATEGORYCHOICES,
    payload: { questionData, selectedStandardQuestion },
  };
};

export const saveStandardQuestionBulkUpload = (
  standardQuestionBulkUpload: StandardQuestionBulkUploadDTO
) => {
  return {
    type: SAVEBULKUPLOADQUESTIONS,
    payload: standardQuestionBulkUpload,
  };
};

export const notifyStandardQuestionIssuesByEmail = (
  standardQuestionBulkUpload: StandardQuestionBulkUploadDTO,
  bulkQuestionUploadPageMode: EnumBulkQuestionUploadPageMode
) => {
  return {
    type: NOTIFYSTANDARDQUESTIONISSUESBYEMAIL,
    payload: {
      StandardQuestionBulkUploadList: standardQuestionBulkUpload,
      BulkQuestionUploadPageMode: bulkQuestionUploadPageMode,
    },
  };
};

export const getRowDataOnClick = (
  questionTypeId: number,
  questionData: QuestionDTO,
  selectedStandardQuestion?: StandardQuestionUploadDTO
) => {
  return {
    type: GETCHOICESDATAONROWCLICK,
    payload: {
      questionTypeId: questionTypeId,
      questionData: questionData,
      selectedStandardQuestion: selectedStandardQuestion,
    },
  };
};
